<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { BaseIcon, BaseButton, InfoArea, CustomerInfo } from "@/components";
import PackageSettigns from "../components/customer/PackageSettigns.vue";
import { getBreadCrumbs } from "../utils/breadcrumb";
import { CurrencySymbol } from "../constants";
import { getItem } from "../utils/tokenTools";
import mixins from "../mixins";

export default {
  name: "Checkout",
  components: {
    BaseIcon,
    BaseButton,
    InfoArea,
    PackageSettigns,
    CustomerInfo,
  },
  mixins: [mixins],
  data() {
    return {
      getPaymentStatuses: [],
      summaryData: [],
      mergedDatasAfterSummaryPull: [],
      totalFundAmount: 0,
      totalCommissionAmount: 0,
      totalNextMonthFundAmount: 0,
      totalNextMonthCommissionAmount: 0,
      packageDetail: null,
      marketInfo: null,
      isPopupVisible: false,
      isWarningAllowed: false,
      totalPriceTl: [],
      totalPriceDollar: [],
      totalPriceEuro: [],
      totalPriceNextMonthTl: [],
      totalPriceNextMonthDollar: [],
      totalPriceNextMonthEuro: [],
      totalPrice: 0,
      totalPriceForeign: 0,
      isButtonClicked: true,
      esube: getItem("esube"),
      IsRecommendationPackage: false,
      isUpgradedPurchase: true,
      showNextMonthRow: false,
      infoText: [
        "Veri paketiniz iptal edilmemesi durumunda bir sonraki ay başında tekrar güncellenecektir.",
        "Komisyon ya da BES/FON büyüklük şartı sağlanması halinde, ilgili ay için belirtilen veri lisans ücreti alınmayacaktır.",
        "Faturalandırma sırasında ay sonu Merkez Bankası kuru dikkate alınacaktır.",
      ],
      customerId: null,
      haveCurrency: false,
      isRecomendedPackage: false,
      isMobile: false,
      isDataHave: [],
    };
  },
  computed: {
    ...mapGetters([
      "customer",
      "packageSummary",
      "getDraftPackageDetails",
      "getMarketInfo",
      "getUserInfo",
      "recommendationSummary",
      "getFilterList",
      "allPackages",
      "getIsUpgradeHappend",
    ]),
    currencySymbol() {
      return CurrencySymbol;
    },
    packageNumber() {
      return this.$route.params.packageNumber;
    },
    getUserNumber() {
      return this.customer.customerNo;
    },
    getCustomerId() {
      return this.customer.id;
    },
    getUserInfos() {
      return `${this.customer.name} ${this.customer.surName}`;
    },
    customerNumber() {
      return this.$route.params.customerNumber;
    },
    screenPrice() {
      if (this.summaryData?.price?.prices == null) {
        return this.summaryData?.nextMonthPrice?.screenPrice;
      } else {
        return this.summaryData?.price?.screenPrice;
      }
    },
    screenFund() {
      if (this.summaryData?.price?.prices == null) {
        return this.summaryData?.nextMonthPrice?.screenFund;
      } else {
        return this.summaryData?.price?.screenFund;
      }
    },
    screenCommission() {
      if (this.summaryData?.price?.prices == null) {
        return this.summaryData?.nextMonthPrice?.screenCommission;
      } else {
        return this.summaryData?.price?.screenCommission;
      }
    },
  },
  mounted() {
    this.customerId =
      this.$route.query.c === undefined
        ? localStorage.getItem("userCusId")
        : this.getCustomerId;
    if (this.esube != "yes") {
      this.getCustomer();
    }
    this.getAllPackages(this.customerId).then(() => {
      this.isDataHave = this.allPackages.data;
    });
    this.getSummary();
    this.isPopupVisible = false;
    if (
      this.$route.query.isReco !== undefined &&
      this.$route.query.isReco == "yes"
    ) {
      this.isRecomendedPackage = true;
    }
    this.isButtonClicked = false;
    this.isUpgradedPurchase =
      this.$route.params.isUpgradedPurchase == undefined
        ? false
        : this.$route.params.isUpgradedPurchase;
    this.getPaymentStatus();
    this.checkIsMobile();
  },
  methods: {
    ...mapActions([
      "getPackageSummary",
      "getRecommendationSummary",
      "confirm",
      "searchCustomer",
      "getDraftPackageDetail",
      "getMarket",
      "getAllPackages",
    ]),
    ...mapMutations([
      "setIsPurchaseOrUpgradeHappend",
      "setBuyMessage",
      "setUpgradeHappend",
    ]),
    getPaymentStatus() {
      const paymentStatuses = this.getFilterList.filter((o) => {
        return o.name === "PaymentStatus";
      });

      if (paymentStatuses.length > 0)
        this.getPaymentStatuses = paymentStatuses[0].values;
    },
    checkIsMobile() {
      if (window.innerWidth < 768) {
        this.isMobile = true;
      }
    },
    goBack() {
      const goBack =
        this.getUserInfo.memberType == "3"
          ? this.$router.go(-1)
          : this.$router.push({
              name: this.$route?.meta?.breadcrumb[2].url.name,
              params: this.$route?.meta?.breadcrumb[2].url.params,
            });
      return goBack;
    },
    addCart(purchaseNo) {
      this.getDraftPackageDetail([purchaseNo, this.customerId]).then(() => {
        this.packageDetail = this.getDraftPackageDetails;
        this.getMarket([
          this.packageDetail.application.applicationId,
          this.packageDetail.platform.platformId,
          this.customerId,
        ]).then(() => {
          this.marketInfo = this.getMarketInfo;
        });
        this.isPopupVisible = true;
      });
    },
    closePopup() {
      if (this.esube != "yes") {
        this.getCustomer();
      }
      this.getSummary();
      this.isPopupVisible = false;
    },
    getCustomer() {
      this.searchCustomer({
        customerNo: this.customerNumber,
        cusId: this.customerId,
      }).then((res) => {
        if (res) {
          getBreadCrumbs({
            breadcrumbs: ["CustomerDetail", "BuyDataPackage", "Checkout"],
            customer: this.customer,
            customerDetail: this.getUserNumber,
            buyDataPackage: this.getUserNumber,
            checkout: this.packageNumber,
            cusId: this.customerId,
          });
        }
      });
    },
    async getSummary() {
      if (this.isRecoQueryDefinedAndYes()) {
        await this.getRecommendationSummaryFunc();
      } else {
        await this.getDraftPackageDetailSummary();
      }
    },

    isRecoQueryDefinedAndYes() {
      return (
        this.$route.query.isReco !== undefined &&
        this.$route.query.isReco === "yes"
      );
    },

    async getRecommendationSummaryFunc() {
      const res = await this.getDraftPackageDetail(this.packageNumber);
      if (res) {
        this.processSummaryData(res.data);
        this.IsRecommendationPackage = true;
      }
    },

    async getDraftPackageDetailSummary() {
      const res = await this.getDraftPackageDetail([this.packageNumber]);
      if (res.data) {
        this.processSummaryData(res.data);
      }
    },

    processSummaryData(data) {
      this.summaryData = data;
      const isWarningAllowed = this.summaryData?.package?.filter(
        (e) =>
          e.perspectiveFeature.name == "Canlı Piyasa" ||
          e.perspectiveFeature.name == "Prime"
      );
      const hasPriceVal = this.summaryData?.package?.filter(
        (e) => e.perspectiveFeature.price != 0
      );
      this.isWarningAllowed = isWarningAllowed.length && hasPriceVal.length;

      this.totalFundAmount = this.summaryData?.price.totalFundAmount;
      this.totalCommissionAmount =
        this.summaryData?.price.totalCommissionAmount;
      this.totalNextMonthFundAmount =
        this.summaryData?.nextMonthPrice.totalFundAmount;
      this.totalNextMonthCommissionAmount =
        this.summaryData?.nextMonthPrice.totalCommissionAmount;
      this.totalPriceTl = this.getPriceByCurrencySymbol("tl");
      this.totalPriceNextMonthTl = this.getNextMonthPriceByCurrencySymbol("tl");
      this.totalPriceDollar = this.getPriceByCurrencySymbol("dolar");
      this.totalPriceNextMonthDollar =
        this.getNextMonthPriceByCurrencySymbol("dolar");
      this.totalPriceEuro = this.getPriceByCurrencySymbol("euro");
      this.totalPriceNextMonthEuro =
        this.getNextMonthPriceByCurrencySymbol("euro");
      this.doubleVendorAndMarketFeature();
    },

    getPriceByCurrencySymbol(symbol) {
      return this.summaryData?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol[symbol]
      )[0];
    },
    getNextMonthPriceByCurrencySymbol(symbol) {
      return this.summaryData?.nextMonthPrice?.prices?.filter(
        (e) => e.info === this.currencySymbol[symbol]
      )[0];
    },
    totalPriceCalc() {
      let totalDollar = this.totalPriceDollar?.totalPrice
        ? " + " +
          this.formatPriceDollar(this.totalPriceDollar?.totalPrice) +
          " USD"
        : "";
      let totalEuro = this.totalPriceEuro?.totalPrice
        ? " + " + this.formatPriceEuro(this.totalPriceEuro?.totalPrice) + " EUR"
        : "";

      if (
        this.totalPriceDollar?.totalPrice !== undefined ||
        this.totalPriceEuro?.totalPrice !== undefined
      ) {
        this.haveCurrency = true;
      }
      return `${
        this.totalPriceTl?.totalPrice !== undefined
          ? this.formatPrice(this.totalPriceTl.totalPrice) + " TL"
          : "0 TL"
      } ${totalDollar}${totalEuro}`;
    },
    totalPriceNextMonthCalc() {
      let totalDollar = this.totalPriceNextMonthDollar?.totalPrice
        ? " + " +
          this.formatPriceDollar(this.totalPriceNextMonthDollar?.totalPrice) +
          " USD"
        : "";
      let totalEuro = this.totalPriceNextMonthEuro?.totalPrice
        ? " + " +
          this.formatPriceEuro(this.totalPriceNextMonthEuro?.totalPrice) +
          " EUR"
        : "";

      if (
        this.totalPriceNextMonthDollar?.totalPrice !== undefined ||
        this.totalPriceNextMonthEuro?.totalPrice !== undefined
      ) {
        this.haveCurrency = true;
      }
      const tlTotal =
        this.totalPriceNextMonthTl &&
        this.totalPriceNextMonthTl.totalPrice !== undefined
          ? this.formatPrice(this.totalPriceNextMonthTl.totalPrice) + " TL"
          : "0 TL";

      return `${tlTotal} ${totalDollar}${totalEuro}`;
    },
    doubleVendorAndMarketFeature() {
      this.mergedDatasAfterSummaryPull = [];
      this.summaryData?.package.forEach((item) => {
        if (item.marketFeature && item.perspectiveFeature) {
          this.mergedDatasAfterSummaryPull.push({
            marketFeature: { name: item.marketFeature.name },
            perspectiveFeature: { name: item.perspectiveFeature.name },
            endDate: item.endDate,
            dateSelection: item.dateSelection,
            totalFundAmount:
              item.marketFeature.fundAmount +
              item.perspectiveFeature.fundAmount,
            totalCommissionAmount:
              item.marketFeature.commissionAmount +
              item.perspectiveFeature.commissionAmount,
            totalPrice:
              item.marketFeature.price + item.perspectiveFeature.price,
          });
        }
        if (
          item.marketFeature &&
          item.vendorFeature &&
          item.vendorFeature.name != "Yok"
        ) {
          this.mergedDatasAfterSummaryPull.push({
            marketFeature: { name: item.marketFeature.name },
            vendorFeature: {
              name: item.vendorFeature.name,
            },
            endDate: item.endDate,
            dateSelection: item.dateSelection,
            totalFundAmount:
              item.marketFeature.fundAmount + item.vendorFeature.fundAmount,
            totalCommissionAmount:
              item.marketFeature.commissionAmount +
              item.vendorFeature.commissionAmount,
            totalPrice: item.marketFeature.price + item.vendorFeature.price,
          });
        }
      });
    },
    confirmPackage() {
      this.isButtonClicked = true;
      const args = {
        purchaseId: Number(this.packageNumber),
        IsRecommendationPackage: this.IsRecommendationPackage,
        cusId: this.customerId,
      };
      this.confirm(args).then((res) => {
        if (res.error) {
          this.$toast.error(res.message);
          this.isButtonClicked = false;
        } else {
          this.setIsPurchaseOrUpgradeHappend(true);
          const checkHas = this.isDataHave.filter(
            (e) => e.id == this.summaryData.id
          );
          if (checkHas == 0 || this.getIsUpgradeHappend) {
            this.$toast.success(
              "Paketiniz en kısa sürede tanımlanacaktır. Kullanıcı adı ve şifre bilgisi gerektiren paketlerde bu bilgiler e-posta ile gönderilmektedir. Lütfen e-posta adresinizde spam klasörünü kontrol ediniz."
            );
            this.setUpgradeHappend(false);
          }
          this.$router.push({
            name: "CustomerDetail",
            params: {
              customerId: this.getCustomerId,
              customerNumber: this.$route.params.customerNumber,
            },
          });
        }
      });
    },
  },
  watch: {
    summaryData(val) {
      const getDateSelection = val?.package?.filter(
        (item) => item?.dateSelection?.key == "1"
      );
      if (getDateSelection.length > 0) {
        this.showNextMonthRow = true;
      } else {
        this.showNextMonthRow = false;
      }
    },
  },
};
</script>

<template>
  <div class="checkout custom-container" :class="esube == 'yes' ? 'mt-20' : ''">
    <div class="breadcrumb" v-if="getUserInfo.memberType == '3'">
      <button @click="goBack" class="back-button">
        <base-icon name="controls-backward" />Geri dön
      </button>
    </div>

    <div class="checkout-customer">
      <customer-info
        :customerNumber="String(customerId)"
        :currentCustomer="customer"
        :getPaymentStatuses="getPaymentStatuses"
      />
    </div>
    <div class="checkout-content">
      <div class="checkout-content__title">
        <h6 id="data-package">Veri Paketleri</h6>
        <div
          class="adjust-btn"
          v-if="!isRecomendedPackage"
          v-show="!isUpgradedPurchase"
        >
          <base-button class="adjust" @click="addCart(packageNumber)">
            <base-icon name="gear"></base-icon>Düzenle
          </base-button>
        </div>
      </div>
      <div class="checkout-content__table">
        <table aria-describedby="data-package" v-if="!isMobile">
          <thead>
            <tr class="package-table">
              <th scope="col">
                <span
                  v-if="
                    summaryData.application != null &&
                    (summaryData.application.applicationId == 3 ||
                      summaryData.application.applicationId == 2)
                  "
                >
                  <span class="app-name">
                    ({{ summaryData.application.name }} -
                    {{ summaryData.application.shortContent }})
                  </span>
                </span>
                <span v-else>
                  <span class="app-name" v-if="summaryData.application != null">
                    ({{ summaryData.application.name }} -
                    {{ summaryData.platform.name }})
                  </span>
                </span>
                <span class="sub-info" v-if="summaryData.purchaseNo">{{
                  summaryData.purchaseNo
                }}</span>
              </th>
              <th scope="col" class="bes">
                BES ve Yatırım Fonu
                <br />Büyüklüğü
                <div class="tag tooltip">
                  <div class="tooltiptext down">
                    <div class="texts">
                      Yatırım Fonu / BES hesaplamasına o ay içerisinde hesapta
                      bulunan ortalama fon büyüklüğü dahil edilir.
                    </div>
                    <div class="triangle-down"></div>
                  </div>
                  <span class="text">
                    <base-icon name="question"></base-icon>
                  </span>
                </div>
              </th>
              <th scope="col">Komisyon</th>
              <th scope="col">Tutar</th>
            </tr>
          </thead>
          <tbody class="separator">
            <tr>
              <td scope="col">Veri Terminali</td>
              <td scope="col">{{ formatPrice(screenFund) }} TL</td>
              <td scope="col">{{ formatPrice(screenCommission) }} TL</td>
              <td scope="col">{{ formatPrice(screenPrice) }} TL</td>
            </tr>
            <tr v-for="d in mergedDatasAfterSummaryPull" :key="d.name">
              <td>
                <span v-if="d.marketFeature && d.marketFeature.name">
                  {{ d.marketFeature.name }}
                  <span v-if="d.marketFeature.name == 'Osmanlı Pro'"> - </span>
                </span>
                <span
                  v-if="d.perspectiveFeature && d.perspectiveFeature.name"
                  >{{ d.perspectiveFeature.name }}</span
                >
                <span v-if="d.vendorFeature && d.vendorFeature.name">
                  {{ d.vendorFeature.name }}
                </span>
                <span v-if="d.endDate" class="small-text">
                  <br />(Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  <br />(Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </td>
              <td>{{ formatPrice(d.totalFundAmount) }} TL</td>
              <td>{{ formatPrice(d.totalCommissionAmount) }} TL</td>
              <td>{{ formatPrice(d.totalPrice) }} TL</td>
            </tr>
          </tbody>

          <thead v-if="summaryData.research && summaryData.research.length > 0">
            <tr class="extra-table">
              <th scope="col">Ek Paketler</th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="summaryData.research && summaryData.research.length > 0">
            <tr v-for="d in summaryData.research" :key="d.name">
              <td v-if="d.researchFeature && d.researchFeature.name">
                {{ d.researchFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  <br />(Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  <br />(Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </td>
              <td v-if="d.researchFeature && d.researchFeature.fundAmount">
                {{ formatPrice(d.researchFeature.fundAmount.toString()) }} TL
              </td>
              <td
                v-if="d.researchFeature && d.researchFeature.commissionAmount"
              >
                {{ formatPrice(d.researchFeature.commissionAmount.toString()) }}
                TL
              </td>
              <td v-if="d.researchFeature && d.researchFeature.price">
                <span v-if="d.researchFeature.priceInfo == '€'">
                  {{ formatPriceEuro(d.researchFeature.price.toString()) }}
                  EUR
                </span>
                <span v-if="d.researchFeature.priceInfo == '$'">
                  {{ formatPriceDollar(d.researchFeature.price.toString()) }}
                  USD
                </span>
                <span v-if="d.researchFeature.priceInfo == '₺'">
                  {{ formatPrice(d.researchFeature.price.toString()) }}
                  TL
                </span>
              </td>
            </tr>
          </tbody>
          <thead
            v-if="
              summaryData.foreignIndice && summaryData.foreignIndice.length > 0
            "
          >
            <tr class="extra-table">
              <th scope="col">Yabancı Endeksler</th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody
            v-if="
              summaryData.foreignIndice && summaryData.foreignIndice.length > 0
            "
          >
            <tr v-for="d in summaryData.foreignIndice" :key="d.name">
              <td v-if="d.foreignIndiceFeature && d.foreignIndiceFeature.name">
                {{ d.foreignIndiceFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  <br />(Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  <br />(Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </td>
              <td
                v-if="
                  d.foreignIndiceFeature && d.foreignIndiceFeature.fundAmount
                "
              >
                {{ formatPrice(d.foreignIndiceFeature.fundAmount) }} TL
              </td>
              <td
                v-if="
                  d.foreignIndiceFeature &&
                  d.foreignIndiceFeature.commissionAmount
                "
              >
                {{ formatPrice(d.foreignIndiceFeature.commissionAmount) }} TL
              </td>
              <td v-if="d.foreignIndiceFeature && d.foreignIndiceFeature.price">
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '₺'">
                  {{ formatPrice(d.foreignIndiceFeature.price) }} TL
                </span>
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '$'">
                  {{ formatPriceDollar(d.foreignIndiceFeature.price) }} USD
                </span>
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '€'">
                  {{ formatPriceEuro(d.foreignIndiceFeature.price) }} EUR
                </span>
              </td>
            </tr>
          </tbody>
          <thead
            v-if="summaryData.algorithm && summaryData.algorithm.length > 0"
          >
            <tr class="extra-table">
              <th scope="col">Algoritmalar</th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody
            v-if="summaryData.algorithm && summaryData.algorithm.length > 0"
          >
            <tr v-for="d in summaryData.algorithm" :key="d.name">
              <td v-if="d.algorithmFeature && d.algorithmFeature.name">
                {{ d.algorithmFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  <br />(Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  <br />(Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </td>
              <td v-if="d.algorithmFeature && d.algorithmFeature.fundAmount">
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl"
                  >{{ formatPrice(d.algorithmFeature.fundAmount) }} TL</span
                >
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                  >{{
                    formatPriceDollar(d.algorithmFeature.fundAmount)
                  }}
                  USD</span
                >
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                  >{{
                    formatPriceEuro(d.algorithmFeature.fundAmount)
                  }}
                  EUR</span
                >
              </td>
              <td
                v-if="d.algorithmFeature && d.algorithmFeature.commissionAmount"
              >
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl">
                  {{ formatPrice(d.algorithmFeature.commissionAmount) }} TL
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                >
                  {{ formatPriceDollar(d.algorithmFeature.commissionAmount) }}
                  USD
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                >
                  {{ formatPriceEuro(d.algorithmFeature.commissionAmount) }}
                  EUR
                </span>
              </td>
              <td v-if="d.algorithmFeature && d.algorithmFeature.price">
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl">
                  {{ formatPrice(d.algorithmFeature.price) }} TL
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                >
                  {{ formatPriceDollar(d.algorithmFeature.price) }} USD
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                >
                  {{ formatPriceEuro(d.algorithmFeature.price) }} EUR
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th scope="col" v-if="showNextMonthRow">Bu Ay Toplam</th>
              <th scope="col" v-if="!showNextMonthRow">Toplam</th>
              <th scope="col">{{ formatPrice(totalFundAmount) }} TL</th>
              <th scope="col">{{ formatPrice(totalCommissionAmount) }} TL</th>
              <th scope="col">{{ totalPriceCalc() }}</th>
            </tr>
            <tr>
              <th scope="col">Gelecek Ay Toplam</th>
              <th scope="col">
                {{ formatPrice(totalNextMonthFundAmount) }} TL
              </th>
              <th scope="col">
                {{ formatPrice(totalNextMonthCommissionAmount) }} TL
              </th>
              <th scope="col">{{ totalPriceNextMonthCalc() }}</th>
            </tr>
          </tfoot>
        </table>
        <div class="mobile-wrap" v-else>
          <div class="row caption">
            <div class="col">
              <span
                v-if="
                  summaryData.application != null &&
                  (summaryData.application.applicationId == 3 ||
                    summaryData.application.applicationId == 2)
                "
              >
                <span class="bold">
                  ({{ summaryData.application.name }} -
                  {{ summaryData.application.shortContent }})
                </span>
              </span>
              <span v-else>
                <span class="bold" v-if="summaryData.application != null">
                  ({{ summaryData.application.name }} -
                  {{ summaryData.platform.name }})
                </span>
              </span>
              <span v-if="summaryData.purchaseNo">{{
                summaryData.purchaseNo
              }}</span>
            </div>
            <div class="col">
              <span class="bold">BES ve Yatırım Fonu <br />Büyüklüğü</span>
            </div>
            <div class="col">
              <span class="bold">Komisyon</span>
            </div>
          </div>
          <div
            class="row"
            v-for="d in mergedDatasAfterSummaryPull"
            :key="d.name"
          >
            <div class="col">
              <span v-if="d.marketFeature && d.marketFeature.name">
                {{ d.marketFeature.name }}
                <span v-if="d.marketFeature.name == 'Osmanlı Pro'"> - </span>
              </span>
              <span v-if="d.perspectiveFeature && d.perspectiveFeature.name">{{
                d.perspectiveFeature.name
              }}</span>
              <span v-if="d.vendorFeature && d.vendorFeature.name">
                {{ d.vendorFeature.name }}
              </span>
              <span v-if="d.endDate" class="small-text">
                (Ay Sonuna Kadar Geçerli)
              </span>
              <span v-if="d.dateSelection.key == 1" class="small-text">
                (Bu Paket Gelecek Ay Başlayacaktır)
              </span>
            </div>
            <div class="col">{{ formatPrice(d.totalFundAmount) }} TL</div>
            <div class="col">{{ formatPrice(d.totalCommissionAmount) }} TL</div>
            <div class="col full-w">
              <span class="bold">Tutar: </span
              >{{ formatPrice(d.totalPrice) }} TL
            </div>
          </div>

          <div
            class="row caption"
            v-if="summaryData.research && summaryData.research.length > 0"
          >
            <div class="col">
              <span class="bold">Ek Paketler</span>
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div>
          <div v-if="summaryData.research && summaryData.research.length > 0">
            <div class="row" v-for="d in summaryData.research" :key="d.name">
              <div
                class="col"
                v-if="d.researchFeature && d.researchFeature.name"
              >
                {{ d.researchFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  (Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  (Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </div>
              <div
                class="col"
                v-if="d.researchFeature && d.researchFeature.fundAmount"
              >
                {{ formatPrice(d.researchFeature.fundAmount.toString()) }} TL
              </div>
              <div
                class="col"
                v-if="d.researchFeature && d.researchFeature.commissionAmount"
              >
                {{ formatPrice(d.researchFeature.commissionAmount.toString()) }}
                TL
              </div>
              <div
                class="col full-w"
                v-if="d.researchFeature && d.researchFeature.price"
              >
                <span v-if="d.researchFeature.priceInfo == '€'">
                  <span class="bold">Tutar: </span
                  >{{ formatPriceEuro(d.researchFeature.price.toString()) }}
                  EUR
                </span>
                <span v-if="d.researchFeature.priceInfo == '$'">
                  <span class="bold">Tutar: </span
                  >{{ formatPriceDollar(d.researchFeature.price.toString()) }}
                  USD
                </span>
                <span v-if="d.researchFeature.priceInfo == '₺'">
                  <span class="bold">Tutar: </span
                  >{{ formatPrice(d.researchFeature.price.toString()) }}
                  TL
                </span>
              </div>
            </div>
          </div>

          <div
            class="row caption"
            v-if="
              summaryData.foreignIndice && summaryData.foreignIndice.length > 0
            "
          >
            <div class="col">
              <span class="bold">Yabancı Endeksler</span>
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div>
          <div
            v-if="
              summaryData.foreignIndice && summaryData.foreignIndice.length > 0
            "
          >
            <div
              class="row"
              v-for="d in summaryData.foreignIndice"
              :key="d.name"
            >
              <div class="col">
                {{ d.foreignIndiceFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  (Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  (Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </div>
              <div
                class="col"
                v-if="
                  d.foreignIndiceFeature && d.foreignIndiceFeature.fundAmount
                "
              >
                {{ formatPrice(d.foreignIndiceFeature.fundAmount) }} TL
              </div>
              <div
                class="col"
                v-if="
                  d.foreignIndiceFeature &&
                  d.foreignIndiceFeature.commissionAmount
                "
              >
                {{ formatPrice(d.foreignIndiceFeature.commissionAmount) }} TL
              </div>
              <div
                class="col full-w"
                v-if="d.foreignIndiceFeature && d.foreignIndiceFeature.price"
              >
                <span class="bold">Tutar: </span>
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '₺'">
                  {{ formatPrice(d.foreignIndiceFeature.price) }} TL
                </span>
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '$'">
                  {{ formatPriceDollar(d.foreignIndiceFeature.price) }} Dolar
                </span>
                <span v-if="d.foreignIndiceFeature.priceInfo.toString() == '€'">
                  {{ formatPriceEuro(d.foreignIndiceFeature.price) }} Euro
                </span>
              </div>
            </div>
          </div>

          <div
            class="row caption"
            v-if="summaryData.algorithm && summaryData.algorithm.length > 0"
          >
            <div class="col">
              <span class="bold">Algoritmalar</span>
            </div>
            <div class="col"></div>
            <div class="col"></div>
          </div>
          <div v-if="summaryData.algorithm && summaryData.algorithm.length > 0">
            <div class="row" v-for="d in summaryData.algorithm" :key="d.name">
              <div
                class="col"
                v-if="d.algorithmFeature && d.algorithmFeature.name"
              >
                {{ d.algorithmFeature.name }}
                <span v-if="d.endDate" class="small-text">
                  (Ay Sonuna Kadar Geçerli)
                </span>
                <span v-if="d.dateSelection.key == 1" class="small-text">
                  (Bu Paket Gelecek Ay Başlayacaktır)
                </span>
              </div>
              <div class="col" v-else>-</div>
              <div
                class="col"
                v-if="d.algorithmFeature && d.algorithmFeature.fundAmount"
              >
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl"
                  >{{ formatPrice(d.algorithmFeature.fundAmount) }} TL</span
                >
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                  >{{
                    formatPriceDollar(d.algorithmFeature.fundAmount)
                  }}
                  USD</span
                >
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                  >{{
                    formatPriceEuro(d.algorithmFeature.fundAmount)
                  }}
                  EUR</span
                >
              </div>
              <div class="col" v-else>-</div>
              <div
                class="col"
                v-if="d.algorithmFeature && d.algorithmFeature.commissionAmount"
              >
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl">
                  {{ formatPrice(d.algorithmFeature.commissionAmount) }} TL
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                >
                  {{ formatPriceDollar(d.algorithmFeature.commissionAmount) }}
                  USD
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                >
                  {{ formatPriceEuro(d.algorithmFeature.commissionAmount) }}
                  EUR
                </span>
              </div>
              <div class="col" v-else>-</div>
              <div
                class="col full-w"
                v-if="d.algorithmFeature && d.algorithmFeature.price"
              >
                <span class="bold">Tutar: </span>
                <span v-if="d.algorithmFeature.priceInfo === currencySymbol.tl">
                  {{ formatPrice(d.algorithmFeature.price) }} TL
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.dolar"
                >
                  {{ formatPriceDollar(d.algorithmFeature.price) }} USD
                </span>
                <span
                  v-if="d.algorithmFeature.priceInfo === currencySymbol.euro"
                >
                  {{ formatPriceEuro(d.algorithmFeature.price) }} EUR
                </span>
              </div>
            </div>
          </div>

          <div class="row result">
            <div class="col">Ekran Ücreti</div>
            <div class="col">{{ formatPrice(screenFund) }} TL</div>
            <div class="col">{{ formatPrice(screenCommission) }} TL</div>
            <div class="col full-w">
              <span class="bold">Tutar: </span>{{ formatPrice(screenPrice) }} TL
            </div>
          </div>
          <div class="row result">
            <div class="col" v-if="showNextMonthRow">Bu Ay Toplam</div>
            <div class="col" v-if="!showNextMonthRow">Toplam</div>
            <div class="col">{{ formatPrice(totalFundAmount) }} TL</div>
            <div class="col">{{ formatPrice(totalCommissionAmount) }} TL</div>
            <div class="col full-w">
              <span class="bold">Tutar: </span>{{ totalPriceCalc() }}
            </div>
          </div>
          <div class="row result">
            <div class="col">Gelecek Ay Toplam</div>
            <div class="col">
              {{ formatPrice(totalNextMonthFundAmount) }} TL
            </div>
            <div class="col">
              {{ formatPrice(totalNextMonthCommissionAmount) }} TL
            </div>
            <div class="col full-w">
              <span class="bold">Tutar: </span>{{ totalPriceNextMonthCalc() }}
            </div>
          </div>
        </div>
      </div>
      <info-area :infoText="infoText[0]" :typeWarning="true"></info-area>
      <info-area
        v-if="isWarningAllowed"
        :infoText="infoText[1]"
        :typeWarning="true"
      ></info-area>
      <info-area
        v-if="haveCurrency"
        :infoText="infoText[2]"
        :typeWarning="true"
      ></info-area>
      <div class="checkout-content__action">
        <base-button
          @click="confirmPackage"
          :class="{ 'button-disabled': isButtonClicked }"
          id="submit-checkout"
          >Talep Et</base-button
        >
      </div>
    </div>
    <template v-if="packageDetail">
      <package-settigns
        :dataItem="packageDetail"
        :marketInfo="marketInfo"
        :isPopupVisible="isPopupVisible"
        @close="closePopup"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.checkout {
  margin: 0px auto;
  padding: 0;
  &.mt-20 {
    margin-top: 20px;
  }
  .back-button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .infoArea {
    position: relative;
    bottom: 0;
    background: var(--grayscale-20);
    color: #000;
    font-size: 13px;
    justify-content: start;
    margin: 20px;
    @media (max-width: 768px) {
      padding: 12px;
      margin: 16px;
    }
  }

  @media (min-width: 1560px) {
    margin: 20px auto;
  }

  ::v-deep .customer-info {
    margin-bottom: 20px;
    .right-side {
      display: none;
    }
  }

  &-content {
    background: var(--grayscale-0);
    position: relative;

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      border-bottom: 1px solid var(--color-primary-tint-second);
      padding: 20px;
    }

    &__table {
      border: solid 1px #e9e9eb;
      border-radius: var(--radius-second);
      overflow-x: auto;
      margin: 20px;
      @media (max-width: 768px) {
        margin: 20px 16px;
      }
      th:first-child {
        min-width: 300px;
      }

      .bes {
        svg {
          position: relative;
          top: 6px;
        }
      }

      table {
        border-collapse: collapse;
        text-indent: 0;
        min-width: 100%;
        overflow: hidden;

        .package-table {
          .sub-info {
            display: block;
            font-weight: 500;
          }
        }
        thead {
          background: var(--color-primary-tint);
          th {
            border-top: none;
            font-size: 12px;
            font-weight: 600;
            height: 52px;
            padding: 0px 20px;
            text-align: center;
            vertical-align: middle;
            &:first-child {
              text-align: left;
            }
            &.bes {
              line-height: 9px;
              .tag {
                line-height: normal;
              }
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid var(--color-primary-tint-second);
            &:last-child {
              border: none;
            }

            td {
              padding: 0px 20px;
              text-align: center;
              font-size: 12px;
              line-height: normal;
              height: 40px;
              vertical-align: middle;
              font-weight: 500 !important;

              &:first-child {
                text-align: left;
              }
            }
          }
          tr:first-child {
            border-top: none;
          }
        }
        tfoot {
          background: var(--color-primary-zebra);
          border-top: 10px solid var(--color-primary-tint);
          tr {
            border-bottom: 1px solid var(--color-primary-tint-second);
            border-top: 1px solid var(--color-primary-tint-second);
            &:last-child {
              border: none;
              background: var(--color-primary-zebra);
            }
            th {
              padding: 0px 20px;
              text-align: center;
              font-size: 12px;
              line-height: normal;
              height: 40px;
              font-weight: 500 !important;
              vertical-align: middle;
              &:first-child {
                text-align: left;
              }
            }
          }

          tr:last-child th:first-child {
            border-bottom-left-radius: 5px;
          }
          tr:last-child th:last-child {
            border-bottom-right-radius: 5px;
          }
        }
      }
      .mobile-wrap {
        border-radius: 5px;
        background: var(--color-primary-tint-second);
        font-size: 12px;
        .row {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 13px;
          flex-wrap: wrap;

          .col {
            flex: 0 0 33%;
            min-height: 58px;
            justify-content: center;
          }

          &.caption {
            flex: 1;

            .col {
              display: flex;
              flex-direction: column;
              &:first-child .bold {
                text-align: left;
              }
              &:last-child {
                align-items: flex-end;
              }
              .bold {
                font-weight: 600;
                text-align: center;
              }
            }
          }
          &.result {
            background: var(--color-primary-zebra) !important;
            .col {
              min-height: 40px;
            }
          }
        }
        .row:not(.caption) {
          background: var(--grayscale-0);
          padding: 0px;
          &.inline {
            display: inline-flex;
          }
          .col {
            display: flex;
            flex-direction: column;
            text-align: center;

            @media (max-width: 768px) {
              flex: 0 0 32%;

              &:first-child {
                padding-left: 12px;
              }
              &:last-child {
                padding-right: 12px;
                box-sizing: border-box;
              }
            }
            &:first-child {
              text-align: left;
            }
            &:nth-child(3) {
              text-align: right;
              position: relative;
              right: 12px;
            }
            &.full-w {
              flex-basis: 100%;
              flex-direction: row;
              justify-content: flex-end;
              align-items: center;
              min-height: 32px;
              gap: 10px;
              @media (max-width: 768px) {
                border-top: 1px solid var(--color-primary-tint-second);
                border-bottom: 1px solid var(--color-primary-tint-second);
              }
            }
            .bold {
              font-weight: 600;
            }
          }
        }
      }
    }

    &__action {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 20px;
      position: relative;
      padding: 20px;

      .warning-text {
        margin-top: 20px;
        margin-right: 10px;
        color: red;
        font-weight: bold;
        @media (min-width: 1220px) {
          position: absolute;
          left: 0px;
        }
        @media (max-width: 1024px) {
          width: 100%;
        }
      }
      @media (max-width: 415px) {
        flex-flow: column;
        .start-time-selectbox {
          width: 100%;
          margin-left: 8px;
        }
      }
      button {
        max-width: 176px;
        margin-top: 15px;
        margin-left: 10px;
        @media (max-width: 415px) {
          max-width: unset;
          width: 100%;
        }
      }
      .form-control-label {
        font-size: 12px;
        color: var(--grayscale-70);
        position: relative;
        padding: 0 7px;
        margin-left: 10px;
        z-index: 2;
        top: 9px;
        background: white;
      }
    }
  }

  .adjust {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .adjust-btn {
    button {
      border: none;
      background-color: transparent;
      color: var(--color-primary-default);
      font-weight: 400;
      font-size: 14px;
      height: auto;
      svg {
        fill: #2c2c30;
        margin-right: 5px;
      }

      &:hover {
        background-color: rgba(234, 234, 236, 0.5);
      }
    }
  }

  .avatar {
    margin-right: 10px;
    img {
      width: 40px;
      height: 40px;
    }
    svg {
      display: block;
      margin: 0 auto;
      width: 40px;
      height: 40px;
    }
  }

  .customer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .small-text {
    font-size: 10px;
    font-weight: 400;
  }
}
</style>
